import React, { FunctionComponent } from 'react';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ListItemText from '@mui/material/ListItemText';
import HomeIcon from '@mui/icons-material/Home';
import { useNavigate } from "react-router-dom";

type NavProps = {
  selectedRoute: string;
}

const Nav: FunctionComponent<NavProps> = ({ selectedRoute }) => {
  const navigate = useNavigate();

  return (
    <List component="nav">
      <ListItemButton selected={selectedRoute === '/'} onClick={() => navigate('/')} >
        <ListItemIcon>
          <HomeIcon />
        </ListItemIcon>
        <ListItemText primary="Home" />
      </ListItemButton>
      <ListItemButton selected={selectedRoute === '/apps'} onClick={() => navigate('/apps')} >
        <ListItemIcon>
          {/*<ShoppingCartIcon />*/}
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="Apps" />
      </ListItemButton>
      {/*<ListItemButton>*/}
      {/*  <ListItemIcon>*/}
      {/*    <PeopleIcon />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText primary="Customers" />*/}
      {/*</ListItemButton>*/}
      {/*<ListItemButton>*/}
      {/*  <ListItemIcon>*/}
      {/*    <BarChartIcon />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText primary="Reports" />*/}
      {/*</ListItemButton>*/}
      {/*<ListItemButton>*/}
      {/*  <ListItemIcon>*/}
      {/*    <LayersIcon />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText primary="Integrations" />*/}
      {/*</ListItemButton>*/}

      {/*<Divider sx={{ my: 1 }} />*/}

      {/*<ListSubheader component="div" inset>*/}
      {/*  Last applications*/}
      {/*</ListSubheader>*/}
      {/*<ListItemButton>*/}
      {/*  <ListItemIcon>*/}
      {/*    <AssignmentIcon />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText primary="Application name" />*/}
      {/*</ListItemButton>*/}
      {/*<ListItemButton>*/}
      {/*  <ListItemIcon>*/}
      {/*    <AssignmentIcon />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText primary="Last quarter" />*/}
      {/*</ListItemButton>*/}
      {/*<ListItemButton>*/}
      {/*  <ListItemIcon>*/}
      {/*    <AssignmentIcon />*/}
      {/*  </ListItemIcon>*/}
      {/*  <ListItemText primary="Year-end sale" />*/}
      {/*</ListItemButton>*/}

    </List>
  );
}

export default Nav;
